"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInput = validateInput;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));
var _rules = require("../../rules");
var _utils = require("../../utils");
var _updateInputStateValueIfChanged = require("../update-input-state-value-if-changed");
function validateInput(inputElement) {
  return function (getState, dispatch) {
    var _context, _context2;
    const {
      formElement,
      inputStates
    } = getState();
    const normalizedValue = (0, _utils.normalizeInputValue)(formElement.elements[inputElement.name]);
    const valueToTest = (0, _find.default)(_context = (0, _concat.default)(_context2 = []).call(_context2, normalizedValue)).call(_context, value => Boolean(value)); // try to find first non-empty value
    const newErrorState = (0, _rules.runValidation)(valueToTest, inputStates.get(inputElement).rules);
    dispatch((0, _updateInputStateValueIfChanged.updateInputStateValueIfChanged)(inputElement, 'errorState', newErrorState));
    return !newErrorState.rule;
  };
}